import React, { Fragment } from 'react';
import { Tooltip, Divider } from 'antd';
import { renderIconDashboard } from '../helpers';
import {OVERFLOW_MESSAGE} from './BlockConstants'

const DashboardButtonBlock = ({ row, handleClic }) => {
  row.processes[0].statusProcess = null;
  let { Icon} = renderIconDashboard(row);
  const title = OVERFLOW_MESSAGE;  
  return (
    <Fragment>
        <Divider type='vertical' />
        <div aria-disabled onClick={handleClic}>
            <Tooltip title={title}>
                {Icon}
            </Tooltip>
        </div>
    </Fragment>
  );
};

export default DashboardButtonBlock;
